import React from 'react'
import { motion } from "framer-motion"
import about_image from "../../../assets/images/about/about-7.png"
import { Link } from 'react-router-dom'
import { slideUp } from '../../../utlits/slideUp'
const AboutFour = () => {
    return (
        <div className="about-area pt-100 pb-75">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <motion.div className="about-image"
                            initial="offscreen"
                            whileInView="onscreen"
                            variants={slideUp(1)}
                            viewport={{ once: true, amount: 0.4 }}
                        >
                            <img src={about_image} alt="about-image" />
                        </motion.div>
                    </div>
                    <div className="col-lg-6">
                        <motion.div className="about-content about-style"
                            initial="offscreen"
                            whileInView="onscreen"
                            variants={slideUp(2)}
                            viewport={{ once: true, amount: 0.4 }}
                        >
                            <div className="title">
                                <span className="d-block">About</span>
                                <h2>Jamie Singley</h2>
                                <p>I am a life long resident of Marion County, MS.  I began my career in public safety in November of 2000.  I began as a 911 dispatcher working my way up through the ranks working as a deputy, narcotics agent, investigator, chief investigator, and currently the chief deputy of the Marion County Sheriff's Office.  I have a love and passion for helping others.  The purpose of this business is to continue giving back to the community life saving skills that will help protect not only ourselves but loved ones as well.  I feel that being willing to help others is a natural thing amongst our area, however the skills to help must be learned.  Real world experience in this area is something I hope no one ever has to see but the reality is, it could happen to you.  Use the experience from expert public safety officials to learn valuable topics so that you are prepared to help in those emergency situations.  Problems are easy to find, but solutions are much harder.  Let me help you with the solutions.</p>
                            </div>
                            
                            <Link className="demo text-decoration-none" to="/contact">Contact Me</Link>
                        </motion.div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AboutFour